import React from 'react'
import { useLocation, useNavigate } from 'react-router';
import { OrderSummary } from '../Components/Page/Order'
import { PaymentForm } from '../Components/Page/Payment'

function Payment() {
  const {
    state: { apiResult, userInput },
  } = useLocation();
  const navigate = useNavigate()
  return (
    <>
    <div className="container m-5 p-5 d-none d-md-block d-lg-block d-xl-block">
        <div className="row">
          <div className="col-md-7">
          <OrderSummary data={apiResult} userInput={userInput} />
          </div>
          <div className="col-md-4 offset-md-1">
            <h3 className="text-success">Payment</h3>
            <div className="mt-5">
             <PaymentForm data={apiResult} userInput={userInput} />
            </div>
          </div>
        </div>
      </div>
      <div className="container d-block d-md-none d-lg-none d-xl-none">
        <div className="row">
          <div className="col-md-7">
          <OrderSummary data={apiResult} userInput={userInput} />
          </div>
          <div className="col-md-4 offset-md-1">
            <h3 className="text-success text-center">Payment</h3>
            <div className="mt-4">
             <PaymentForm data={apiResult} userInput={userInput} />
            </div>
            <button className="btn btn-secondary mt-3 mb-3" style={{marginLeft: "28%"}} onClick={() => navigate(-1)}>
              Back to Orders
            </button>
          </div>
        </div>
      </div>
    </> 
  )
}

export default Payment